'use strict';
import angular from 'angular';
import _ from 'lodash';
import owlCarouselHtmlUrl from '../views/directives/owlcarousel.html';
import EventBus from "../../../../../grok/src/modules/core/app/helpers/EventBus";

angular.module('core.owlcarousel.directives', [])
    .component('carouselAfter', {})
    .directive('owlCarousel', owlCarousel)
    .directive('owlCarouselItem', owlCarouselItem);

/**
 * @ngInject
 */
function owlCarousel() {
    return {
        templateUrl: owlCarouselHtmlUrl,
        bindToController: true,
        scope: {
            options: '<',
            items: '<',
            itemComponent: '<',
        },
        controllerAs: 'vm',
        controller: OwlCarouselController
    };
}

/**
 * @ngInject
 */
function owlCarouselItem() {
    return {
        bindToController: true,
        replace: true,
        scope: {
            item: '<',
            component: '<'
        },
        controllerAs: 'vm',
        controller: OwlCarouselItemController
    };
}

/**
 * @ngInject
 */
function OwlCarouselController(
    $element,
    $timeout
) {
    var vm = this;
    var defaultOptions = {
        autoHeight: true,
        margin: 10,
        items: 3,
        dots: true,
        loop: true,
        nav: false,
        responsiveClass: true
    };
    let observer = null;
    let fallbackTimer = null;

    vm.initOwlCarousel = initOwlCarousel;
    vm.$owlCarouselEl = $element.find('div.owl-carousel');
    vm.$onInit = $onInit;
    vm.$postLink = $postLink;
    vm.$onChanges = $onChanges;
    vm.$onDestroy = $onDestroy;

    function $onInit() {
        vm.isReady = false;
        vm.options = _.extend(defaultOptions, vm.options || defaultOptions);
        vm.$owlCarouselEl = $element.find('div.owl-carousel');
        initOwlCarousel();

        // when we're exporting a dashboard we need to notify the export.directives that the carousel exists
        if (window.dashExport) {
            EventBus.signal('export-carousel-loaded', vm.$owlCarouselEl, vm.items);
        }
    }

    function $postLink() {
    }

    function $onChanges() {
        initOwlCarousel();
    }

    function $onDestroy() {
        destroyOwlCarousel();
    }

    function initOwlCarousel() {
        $timeout(function() { // Timeout must be used in order to correctly instantiate owl carousel on angular bound elements
            vm.$owlCarouselEl.owlCarousel(vm.options);
            vm.isReady = true;

            if (vm.items.length) {
                if (observer !== null) {
                    observer.disconnect();
                }
                // Only trigger refresh when DOM children are injected
                observer = new MutationObserver(function (mutationsList, obs) {
                    if (vm.$owlCarouselEl.height() > 30) {
                        vm.$owlCarouselEl.trigger('refresh.owl.carousel', [100]);
                        clearTimeout(fallbackTimer);
                        obs.disconnect();
                        observer = null;
                        fallbackTimer = null;
                    }
                });

                observer.observe(vm.$owlCarouselEl[0], {
                    childList: true,
                    subtree: true,
                });

                setTimeout(function () {
                    if (observer !== null) {
                        observer.disconnect();
                    }
                }, 5000); // Fallback to disconnect observer after 5 seconds if no height change is detected
            }
          
            if (vm.options.onChange) {
                vm.$owlCarouselEl.on('changed.owl.carousel', function(e) {
                    vm.options.onChanged(e);
                });
            }
        }, 0);
    }

    function destroyOwlCarousel() {
        vm.$owlCarouselEl.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
        vm.$owlCarouselEl.find('.owl-stage-outer').children().unwrap();
        if (observer !== null) {
            observer.disconnect();
        }

        if (fallbackTimer !== null) {
            clearTimeout(fallbackTimer);
        }
    }
}

/**
 * @ngInject
 */
function OwlCarouselItemController(
    $scope,
    $element,
    $compile
) {
    var vm = this;
    vm.$postLink = $postLink;

    function $postLink() {
        var $newScope = $scope.$new(true);
        $newScope.item = vm.item;
        var component = $compile(vm.component)($newScope);
        $element.append(component);
    }
}